'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z' });

var Accessibility = function Accessibility(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Accessibility = (0, _pure2.default)(Accessibility);
Accessibility.muiName = 'SvgIcon';

exports.default = Accessibility;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Accessibility.js
// module id = 2082
// module chunks = 0